import { LOGO } from "../lib/api";
import { useI18n } from "../lib/LanguageContext";
export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-teal/10 mt-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <img src={LOGO} alt="GIDZA" className="h-12 mb-4"/>
          <p className="text-sm text-muted-foreground max-w-xs">{t("footer.description")}</p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">{t("footer.ecosystem")}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>NUNA — Nutrition Analysis</li><li>{t("footer.education")}</li><li>{t("footer.store")}</li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>{t("footer.privacy")}</li><li>{t("footer.terms")}</li><li>{t("footer.contact")}</li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">{t("footer.sources")}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>TKPI (Indonesia)</li><li>Thai FCT</li><li>Malaysian FCT</li><li>Korean Nutrition DB</li><li>USDA FoodData Central</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-teal/10 py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} GIDZA INSTITUTE — {t("footer.rights")}
      </div>
    </footer>
  );
}
